module.exports = __webpack_public_path__ + "static/media/send-disabled.159e3884.png";